require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-sankt-andrae-am-zicksee.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-sankt-andrae-am-zicksee");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-sankt-andrae-am-zicksee!./.cache/json/betreuungseinrichtungen-neusiedl-sankt-andrae-am-zicksee.json
// module id = 964
// module chunks = 231608221292675